import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { distinctUntilChanged } from 'rxjs/operators';
import { ParametroService } from 'src/app/services/parametro.service';
import { SucursalService } from 'src/app/services/sucursal.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';

interface ParametroSucursal {
  parametro_codigo: number,
  empresa_rut: number,
  sucursal_codigo: number,
  sucursal_nombre: string,
  valor: string,
  valor_booleano: string,
}

@Component({
  selector: 'app-agregar-editar-parametro',
  templateUrl: './agregar-editar-parametro.component.html',
  styleUrls: ['./agregar-editar-parametro.component.scss']
})
export class AgregarEditarParametroComponent implements OnInit {
  @ViewChild('addEditParametro', { static: true }) addEditParametroModal: ModalDirective;
  @Output() onGuardar: EventEmitter<void> = new EventEmitter();

  tiposParametro: any[];
  sucursales: any[];
  opcionesBooleanas: any[];

  formParametro: FormGroup;
  parametro: any;

  // UTILS
  mode: 'ADD' | 'EDIT';
  rut_empresa: number;
  rut_usuario: number;
  codigo_sucursal: number;
  mostrarValorSucursalEmpresa: boolean;

  // FLAG: Sirve para saber si se debe quitar la sucursal
  flagQuitarSucursal: boolean;

  // LOG
  private log: any;

  constructor(
    private _fb: FormBuilder,
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private clog: ConsoleService,
    private sucursalService: SucursalService,
    private parametroService: ParametroService
  ) {
    this.log = this.clog.log('PARAMETROS MODAL ADD/EDIT');
  }

  ngOnInit() {
    this.configurarVariablesFijas();
    this.obtenerSucursales();
  }

  onClosed(event: any) {
    this.mostrarValorSucursalEmpresa = false;
    this.formParametro.reset();
    this.formParametro.get('sucursalesSeleccionada').setValue([]);
    this.parametroSucursales.clear();
    this.parametroSucursales.setValue([]);
    // this.addEditParametroModal.hide();
  }

  configurarSuscribersForm() {
    this.formParametro.get('nombre').valueChanges.subscribe((value: string) => {
      // TRANSFORMAR A MAYUSCULAS
      if (value) this.formParametro.get('nombre').setValue(value.toUpperCase().trim(), { emitEvent: false });
    });
    this.formParametro.get('descripcion').valueChanges.subscribe((value) => {
      // VALIDAR QUE NO TENGA MAS DE 100 CARACTERES
      if (value) {
        if (value.length > 100) this.formParametro.get('descripcion').setErrors({ max: true });
      }
    });


    this.formParametro.get('sucursalesSeleccionada').valueChanges
    .pipe(distinctUntilChanged())
    .subscribe((value: number[]) => {
      if (value) this.configurarFormParametroSucursal(value);
    });

    this.formParametro.get('tipo_parametro_codigo').valueChanges.subscribe((value) => {
      if (value !== null) this.mostrarValorSucursalEmpresa = true;
    });
    // SI LA PROPIEDAD es_empresa O es_sucursal SON DESELECCIONADOS, SE DEBE RESETEAR TODAS LAS PROPIEDADES DE LA SECCION
    // SI SE DESELECCIONA es_empresa, SE DEBE RESETEAR EL FORMGROUP parametroEmpresa
    this.formParametro.get('es_empresa').valueChanges.subscribe((value) => {
      if (!value) this.formParametro.get('parametroEmpresa').reset();
    });
    // SI SE DESELECCIONA es_sucursal, SE DEBE QUITAR TODOS LOS ELEMENTOS DEL FORMARRAY listParametroSucursal
    // this.formParametro.get('es_sucursal').valueChanges.subscribe((value) => {
    //   if (!value) {
    //     if (confirm('¿Está seguro de quitar todas las sucursales?')) {
    //       this.formParametro.get('sucursalesSeleccionada').setValue([]);
    //       this.parametroSucursales.clear();
    //       this.parametroSucursales.setValue([]);
    //     } else {
    //       this.formParametro.get('es_sucursal').setValue(true);
    //     }
    //   }
    // });
  }

  onChangeCheckEmpresa(){
    const value = !this.formParametro.get('es_empresa').value;
    if (!value) {
      this.formParametro.get('parametroEmpresa').reset();
    }else{
      this.formParametro.get('parametroEmpresa').get('empresa_rut').setValue(this.rut_empresa);
      this.formParametro.get('es_empresa').setValue(true);
    }
  }

  onChangeCheckSucursal(){
    if (this.parametroSucursales.length === 0) return;

    const value = !this.formParametro.get('es_sucursal').value;
    if (!value) {
      if (confirm('¿Está seguro de quitar todas las sucursales?')) {
        this.formParametro.get('sucursalesSeleccionada').setValue([]);
        this.parametroSucursales.clear();
        this.parametroSucursales.setValue([]);
      } else {
        this.formParametro.get('es_sucursal').setValue(true);
      }
    }
  }
  
  // CONFIGURAR FORM PARAMETRO SUCURSAL
  configurarFormParametroSucursal(value: number[]) {
    if (!value) return;
    // SE DEBE VERIFICAR LOS CODIGOS, SI HAY UN CODIGO EN VALUE QUE NO ESTE EN EL ARRAY DE listParametroSucursal, SE DEBE AGREGAR
    const listParametroSucursal = this.formParametro.get('listParametroSucursal').value;
    const listParametroSucursalTemp = [...listParametroSucursal];
    const sucursalesExistentes = new Set(listParametroSucursalTemp.map(y => y.sucursal_codigo));
    const sucursalesAgregar = value.filter(x => !sucursalesExistentes.has(x));
    const sucursalesQuitar = listParametroSucursalTemp.filter(x => !value.includes(x.sucursal_codigo));
    sucursalesAgregar.forEach((x) => {
      const nombreSucursal = this.sucursales.find(y => y.value === x).label;
      this.parametroSucursales.push(this._fb.group({
        sucursal_codigo: new FormControl(x), 
        valor: new FormControl('', Validators.required), 
        valor_booleano: new FormControl('true'),
        sucursal_nombre: new FormControl(nombreSucursal || 'Nombre desconocido'),
        rut_empresa: new FormControl(this.rut_empresa),
      }));
    });
    if (this.flagQuitarSucursal) {
      sucursalesQuitar.forEach((x) => {
        const index = listParametroSucursalTemp.findIndex(y => y.sucursal_codigo === x.sucursal_codigo);
        this.quitarSucursal(index, false);
      });
    }else{
      this.flagQuitarSucursal = true;
    }
  }
  quitarSucursal(index: number, modifyformParametro: boolean = true) {
    this.parametroSucursales.removeAt(index);
    const sucursalesSeleccionadas = this.parametroSucursales.value.map(x => x.sucursal_codigo) as number[];
    if (modifyformParametro){
      this.flagQuitarSucursal = false;
      this.formParametro.get('sucursalesSeleccionada').setValue(sucursalesSeleccionadas);
    }
  }

  obtenerSucursales() {
    this.sucursales = [];
    this.sucursalService.obtenerSucursalxEmpresa({rut_empresa: this.rut_empresa}, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.toastService.error('Error al obtener las sucursales', 'Error sucursales', { timeOut: 10000 });
        return;
      }
      this.sucursales = respuesta.registros.filter(x => x.activo === true).map(x => ({ value: x.codigo, label: x.nombre }));
    })
  }
  configurarFormGroup() {
    if (this.mode === 'ADD') {
      this.formParametro = this._fb.group({
        codigo: new FormControl(null),
        nombre: new FormControl('', Validators.required),
        descripcion: new FormControl(''),
        tipo_parametro_codigo: new FormControl(null, Validators.required),
        activado: new FormControl(true, Validators.required),
        es_empresa: new FormControl(false),
        es_sucursal: new FormControl(false),
        sucursalesSeleccionada: new FormControl([]),
        parametroEmpresa: new FormGroup({
          empresa_rut: new FormControl(this.rut_empresa),
          valor: new FormControl(null),
          valor_booleano: new FormControl(null),
        }),
        listParametroSucursal: this._fb.array([]),
      });
    }
    if (this.mode === 'EDIT') {
      this.formParametro = this._fb.group({
        codigo: new FormControl(this.parametro.codigo),
        nombre: new FormControl(this.parametro.nombre, Validators.required),
        descripcion: new FormControl(this.parametro.descripcion),
        tipo_parametro_codigo: new FormControl(this.parametro.tipo_parametro_codigo, Validators.required),
        activado: new FormControl(this.parametro.activado, Validators.required),
        es_empresa: new FormControl(this.parametro.es_empresa),
        es_sucursal: new FormControl(this.parametro.es_sucursal),
        sucursalesSeleccionada: new FormControl(this.parametro.sucursalesSeleccionada),
        parametroEmpresa: new FormGroup({
          empresa_rut: new FormControl(this.rut_empresa),
          valor: new FormControl(null),
          valor_booleano: new FormControl(null),
        }),
        listParametroSucursal: this._fb.array([]),
      });

      // this.mostrarValorSucursalEmpresa = this.parametro.parametroEmpresa || this.parametro.listParametroSucursal.length > 0;

      // SI EXISTE PARAMETRO EMPRESA, SE DEBE AGREGAR AL FORMGROUP parametroEmpresa
      if (this.parametro.parametroEmpresa) {
        this.formParametro.get('parametroEmpresa').get('valor').setValue(this.parametro.parametroEmpresa.valor);
        this.formParametro.get('parametroEmpresa').get('valor_booleano').setValue(this.parametro.parametroEmpresa.valor);
      }
      // SI EXISTE PARAMETRO SUCURSAL, SE DEBE AGREGAR AL FORMARRAY listParametroSucursal
      if (this.parametro.listParametroSucursal) {
        this.parametro.listParametroSucursal.forEach((x: ParametroSucursal) => {
          const nombreSucursal = this.sucursales.find(y => y.value === x.sucursal_codigo).label;
          this.parametroSucursales.push(this._fb.group({
            sucursal_codigo: new FormControl(x.sucursal_codigo), 
            valor: new FormControl(x.valor, Validators.required), 
            valor_booleano: new FormControl(x.valor),
            sucursal_nombre: new FormControl(nombreSucursal || 'Nombre desconocido'),
            rut_empresa: new FormControl(this.rut_empresa),
          }));
        });
      }
    }
  }

  get parametroSucursales(){
    return this.formParametro.controls['listParametroSucursal'] as FormArray;
  }

  configurarVariablesFijas() {
    this.mostrarValorSucursalEmpresa = false;
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.rut_usuario = this.accesolocalstorage.getRutUsuario();
    this.codigo_sucursal = this.accesolocalstorage.getSucursalCodigo();
    this.tiposParametro = [
      {value: 1, label: 'Numerico'},
      {value: 2, label: 'Booleano'},
      {value: 3, label: 'Texto'},
    ]
    this.opcionesBooleanas = [
      {value: 'true', label: 'Si'},
      {value: 'false', label: 'No'},
    ]
    // {value: 4, label: 'Fecha'},
    // {value: 5, label: 'Fecha y Hora'},
    this.sucursales = [];
  }

  showAddModal(){
    this.mode = 'ADD';
    this.configurarFormGroup();
    this.configurarSuscribersForm();
    this.addEditParametroModal.show();
  }
  showEditModal(parametro: any){
    this.mode = 'EDIT';
    this.cargarParametro(parametro);
    this.addEditParametroModal.show();
    this.mostrarValorSucursalEmpresa = true;
  }
  cargarParametro(codigo: number) {
    this.parametroService.obtenerSegunCodigoParametro(codigo, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.toastService.error('Error al obtener el parametro', 'Error parametro', { timeOut: 10000 });
        return;
      }
      this.parametro = respuesta.registros[0];
      this.parametro.sucursalesSeleccionada = this.parametro.listParametroSucursal.map(x => x.sucursal_codigo);
      
      if (this.parametro.tipo_parametro_codigo === 2) {
        if (this.parametro.parametroEmpresa) {
          // EMPRESA
          this.parametro.parametroEmpresa.valor_booleano = this.parametro.parametroEmpresa.valor;
        }
        if (this.parametro.listParametroSucursal) {
          // SUCURSALES
          this.parametro.listParametroSucursal = this.parametro.listParametroSucursal.map((x: any) => {
            x.valor_booleano = x.valor;
            return x;
          });
        }
      }
      this.configurarFormGroup();
      this.configurarSuscribersForm();
    })
  }

  guardar(){
    if (this.mode === 'ADD') this.guardarParametro();
    if (this.mode === 'EDIT') this.editarParametro();
  }
  guardarParametro() {
    const formParametro = this.formParametro.value;
    // VALIDACIONES
    if (!this.validarForm(formParametro)) return;

    const parametro = this.procesarParametro(formParametro);
    
    const inputParams = {
      entidad: parametro
    }
    this.log('GUARDAR PARAMETRO', inputParams);
    this.parametroService.guardarParametroConEmpresaSucursal(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        console.log(mensajes);
        this.toastService.error('Error al guardar el parametro', 'Error parametro', { timeOut: 10000 });
        return;
      }
      this.toastService.success('Parametro guardado correctamente', 'Guardado', { timeOut: 10000 });
      this.onGuardar.emit();
      this.cerrarModal();
    });
  }
  editarParametro() {
    const formParametro = this.formParametro.value;
    // VALIDACIONES
    if (!this.validarForm(formParametro)) return;

    const parametro = this.procesarParametro(formParametro);
    
    const inputParams = {
      entidad: parametro
    }
    this.log('GUARDAR PARAMETRO', inputParams);
    this.parametroService.editarParametroConEmpresaSucursal(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        console.log(mensajes);
        this.toastService.error('Error al editar el parametro', 'Error parametro', { timeOut: 10000 });
        return;
      }
      this.toastService.success('Parametro editado correctamente', 'Editado', { timeOut: 10000 });
      this.onGuardar.emit();
      this.cerrarModal();
    })
  }
  procesarParametro(formParametro: any) {
    const parametro = {
      ...formParametro,
      empresa_rut: this.rut_empresa,
      usuario_rut: this.rut_usuario,
      sucursal_codigo: this.codigo_sucursal,
    }
    // ELIMINO LA PROPIEDAD sucursalesSeleccionada PORQUE NO SE OCUPA EN EL BACKEND, POR AHORA
    delete parametro.sucursalesSeleccionada;

    if (parametro.tipo_parametro_codigo === 2) {
      // EMPRESA
      parametro.parametroEmpresa.valor = parametro.parametroEmpresa.valor_booleano;
      // SUCURSALES
      parametro.listParametroSucursal = parametro.listParametroSucursal.map((x: any) => {
        x.valor = x.valor_booleano;
        return x;
      });
      this.eliminarPropiedades(parametro);
    }else{
      // ELIMINAMOS LAS PROPIEDADES
      this.eliminarPropiedades(parametro);
    }
    return parametro;
  }
  cerrarModal() {
    this.mostrarValorSucursalEmpresa = false;
    this.formParametro.reset();
    this.formParametro.get('sucursalesSeleccionada').setValue([]);
    this.parametroSucursales.clear();
    this.parametroSucursales.setValue([]);
    this.addEditParametroModal.hide();
  }
  private validarForm(formParametro: any): boolean {
    // SI NO ESTA SELECCIONADO LA EMPRESA O SUCURSAL, DAR ERROR
    // if (!formParametro.es_empresa && !formParametro.es_sucursal) {
    //   this.toastService.error('Debe seleccionar Empresa o Sucursal', 10000);
    //   return false;
    // }
    // VERIFICAR SI EXISTE VALOR EN PARAMETRO EMPRESA
    if (formParametro.es_empresa && formParametro.parametroEmpresa.valor === '' && formParametro.parametroEmpresa.valor_booleano === '') {
      this.toastService.error('Debe ingresar un valor para la empresa', 'Error valor', { timeOut: 10000 });
      return false;
    }
    // VERIFICAR SI EXISTE VALOR EN LA LISTA PARAMETRO SUCURSAL
    if (formParametro.es_sucursal && formParametro.listParametroSucursal.some(x => x.valor === '' && x.valor_booleano === '') === 0) {
      this.toastService.error('Debe ingresar un valor para la sucursal', 'Error valor', { timeOut: 10000 });
      return false;
    }
    // SI LA PROPIEDAD NOMBRE TIENE ESPACIOS, DAR ERROR
    if (formParametro.nombre.includes(' ')) {
      this.toastService.error('El nombre no puede contener espacios', 'Error nombre parametro', { timeOut: 10000 });
      return false;
    }
    // VERIFICAR LA CANTIDAD DE CARACTERES DE LA DESCRIPCION
    if (formParametro.descripcion.length > 100) {
      this.toastService.error('La descripción no puede tener más de 100 caracteres', 'Error descripción', { timeOut: 10000 });
      return false;
    }
    // SI EL TIPO PARAMETRO ES 1, SOLO DEBE HABER NUMERO EN VALOR
    // EMPRESA
    if (formParametro.tipo_parametro_codigo === 1) {
      if (isNaN(formParametro.parametroEmpresa.valor)) {
        this.toastService.error('El valor debe ser un número', 'Error valor', { timeOut: 10000 });
        return false;
      }
    }
    //SUCURSAL
    if (formParametro.tipo_parametro_codigo === 1) {
      const listParametroSucursal = formParametro.listParametroSucursal;
      const errores = listParametroSucursal.some(x => isNaN(x.valor));
      if (errores) {
        this.toastService.error('El valor debe ser un número', 'Error valor', { timeOut: 10000 });
        return false;
      }
    }
    return true;
  }

  private eliminarPropiedades(parametro: any) {
    delete parametro.parametroEmpresa.valor_booleano;
    parametro.listParametroSucursal = parametro.listParametroSucursal.map((x: any) => {
      delete x.valor_booleano;
      delete x.sucursal_nombre;
      return x;
    });
  }
}

